<template>
  <div class="shipping-address-selector w-100">
    <el-radio-group class="w-100" v-model="model" v-if="shippingAddress.length">
      <div v-for="address in shippingAddress" :key="address.id">
        <div class="row address-row mx-0">
          <div class="col-10 px-0">
            <el-radio
                class="w-100 checkout-text-phone"
                :label="address.id"
                :disabled="disabled || !address.distribution_support"
                border @dbclick="editAddress(address.id)"
            >
            <!--【{{ address.label }}】-->
            <!--{{ address.consignee }}-->
            <!--{{ address.mobile }}-->
            <!--{{ address.zipcode }}-->
            <!--{{ address.country_name }}-->
            <!--{{ address.zone_name }}-->
            <!--{{ address.line1 }}-->
            <!--{{ address.line2 }}-->
            <template v-if="address.additional_information">({{ address.additional_information }})</template>
              <span style="position: absolute">
                        <el-popover
                          placement="right"
                          width="300"
                          trigger="click">
                【{{ address.label }}】
                {{ address.consignee }}
                {{ address.mobile }}
                {{ address.zipcode }}
                {{ address.country_name }}
                {{ address.zone_name }}
                {{ address.line1 }}
                {{ address.line2 }}
                <el-button slot="reference" class="px-0" style="padding: 0!important;border:none;white-space: nowrap;overflow: hidden;text-overflow:ellipsis;" :style="isMobile ? 'max-width: 200px' : ''">【{{ address.label }}】
                {{ address.consignee }}
                {{ address.mobile }}
                {{ address.zipcode }}
                {{ address.country_name }}
                {{ address.zone_name }}
                {{ address.line1 }}
                {{ address.line2 }}
                </el-button>
              </el-popover>
              </span>
            </el-radio>
          </div>

          <div class="col-2 px-0" v-show="!disabled">
            <button type="button" @click="editAddress(address.id)" class="btn btn-link set-default">
              {{ $t('shipping_address.edit_address') }}
            </button>
          </div>
        </div>

      </div>
    </el-radio-group>
    <div v-else>
      {{ $t('proxy_request.please_add_shipping_address') }}
    </div>
    <div v-if="!disabled">
      <el-button @click="editAddress(0)" type="primary">{{ $t('checkout.add_shipping_address') }}</el-button>
    </div>
    <save-shipping-address-dialog :editId="editId"></save-shipping-address-dialog>
  </div>
</template>

<script>
  import _ from 'lodash';
  import { mapState, mapGetters } from 'vuex';
  import SaveShippingAddressDialog from '@/components/user/SaveShippingAddressDialog.vue';
  import { SET_SHIPPING_ADDRESS_DIALOG } from '@/store/mutation-types';

  export default {
    name: 'ShippingAddressSelector',
    model: {
      prop: 'address_id',
      event: 'change',
    },
    props: {
      address_id: {},
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        editId: null,
      };
    },
    mounted() {
      if (!this.shippingAddress.length) {
        // 獲取收貨地址
        this.$store.dispatch('fetchShippingAddress').then(() => {
          this.setDefaultAddressId();
        }).catch(() => {
          this.$notify({
            type: 'danger',
            title: this.$t('checkout.get_shipping_address_err'),
          });
        });
      } else {
        this.setDefaultAddressId();
      }
    },
    computed: {
      ...mapState({
        shippingAddress: state => state.user.shippingAddress,
      }),
      ...mapGetters([
        'isMobile',
      ]),
      shippingAddressDialog: {
        get() {
          return this.$store.state.user.shippingAddressDialog;
        },
        set(val) {
          this.$store.commit(SET_SHIPPING_ADDRESS_DIALOG, val);
        },
      },
      model: {
        get() {
          return this.address_id;
        },
        set(val) {
          this.$emit('change', val);
        },
      },
    },
    methods: {
      editAddress(id) {
        this.editId = id;
        this.shippingAddressDialog = true;
      },
      setDefault(id) {
        this.$store.dispatch('setDefaultShippingAddress', id);
      },
      setDefaultAddressId() {
        if (!this.address_id) {
          const defaultAddress = _.find(this.shippingAddress, { default: true, distribution_support: true });
          if (defaultAddress) {
            this.model = defaultAddress.id;
          }
        }
      },
    },
    components: {
      SaveShippingAddressDialog,
    },
  };
</script>

<style lang="scss">
  @import "../../styles/helpers/variables";
  .shipping-address-selector {
    .checkout-text-phone {
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    overflow-x: hidden;
    .set-default {
      color: $brand-primary;
      margin: 0;
    }
  }
</style>
